import React from 'react';
import Modal from 'react-bootstrap/Modal';
import Button from '../Styles/Button.module.css';

const CustomModal = ({ open, handleDeleteClose, handleConfirm,jobData, title, description }) => {
 
  return (
    <Modal className='deleteContant' show={open} onHide={handleDeleteClose} aria-labelledby="alert-dialog-title" aria-describedby="alert-dialog-description">
      <Modal.Body>{description}</Modal.Body>
      <Modal.Footer>
        <button className={Button.brownBorderBtn} onClick={handleDeleteClose}>
          No
        </button>
        <button className={Button.greenBtn} onClick={()=>handleConfirm(jobData)} autoFocus>
          Yes
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default CustomModal;
